// eslint-disable-next-line import/prefer-default-export
export const safeJsonParse = (str) => {
	try {
		return JSON.parse(str);
	} catch (e) {
		return null;
	}
};
